import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles';
import FloatingAction from './FloatingAction'

const useStyles = makeStyles(theme => (
    {
        list: props => ({
            padding: theme.spacing(props.spacing),
            width: "fit-content",
            position: props.position,
            display: "flex",
            flexDirection: props.orientation === "horizontal" ? "row" : props.orientation === "vertical" ? "column" : "row",
            right: 0,
            bottom: 0,
            zIndex: 10,
            '& > *': {
                margin: theme.spacing(1),
            },
        }),
    }
));

const FloatingActionList = props => {

    const classes = useStyles(props);

    const { children, onListActionClick } = props

    return (
        <div className={classes.list}>
            {React.Children.map(children, child => {
                return React.cloneElement(child, { ...child.props, position: "relative",})
            })}
        </div>
    )
}

FloatingActionList.propTypes = {
    variant: PropTypes.oneOf(["extended", "round"]),
    color: PropTypes.oneOf(["primary", "secondary", "inherit", "default"]),
    orientation: PropTypes.oneOf(["horizontal", "vertical"]),
    /**
     * Add onclick action for every child item
     * Every child component require id prop to identify when is clicked
     * onActionClick returns id prop of component (id) => {console.log(id)}
     */
    onActionClick: PropTypes.func
}

FloatingActionList.defaultProps = {
    spacing: 0,
    position: "fixed",
    
};

export default FloatingActionList
